{
  "prefixes": [
    "/lernen",
    "/upl",
    "/academy",
    "/academy_partner",
    "/academy_partners",
    "/inertia-test",
    "/impressum",
    "/datenschutz",
    "/agb",
    "/business/agb",
    "/ueber_uns",
    "/ueber-studyflix",
    "/jobs-bei-studyflix",
    "/partner-werden",
    "/e-learning",
    "/abiwettbewerb2027",
    "/partner",
    "/users/sign_in",
    "/users/authentication_provider/from_native_app",
    "/users/password",
    "/users/confirmation",
    "/users/sign_up",
    "/user/danke",
    "/users/onboarding",
    "/users/registration_steps/from_authentication_provider",
    "/users/registration_steps/education_info",
    "/users/registration_steps/study_info",
    "/users/edit",
    "/user/edit",
    "/users/home",
    "/users/merkliste",
    "/users/historie",
    "/custom_playlists",
    "/:subject_area/thema",
    "/ausbildung/bundeswehr",
    "/ausbildung/angebote",
    "/jobs/angebote",
    "/studium/angebote",
    "/events/termine",
    "/ausbildung/duale-studienplaetze/alle-berufsfelder",
    "/ausbildung/duale-studienplaetze/alle-unternehmen",
    "/ausbildung/duale-studienplaetze/alle-staedte",
    "/ausbildung/ausbildungsplaetze/alle-berufsfelder",
    "/ausbildung/ausbildungsplaetze/alle-unternehmen",
    "/ausbildung/ausbildungsplaetze/alle-staedte",
    "/jobs/stellenangebote/alle-berufsfelder",
    "/jobs/stellenangebote/alle-unternehmen",
    "/jobs/stellenangebote/alle-staedte",
    "/jobs/traineestellen/alle-berufsfelder",
    "/jobs/traineestellen/alle-unternehmen",
    "/jobs/traineestellen/alle-staedte",
    "/ausbildung/berufe-a-z",
    "/jobs/berufe-a-z",
    "/ausbildung/unternehmen",
    "/jobs/unternehmen",
    "/studium/unternehmen",
    "/events/unternehmen"
  ],
  "paths": ["/", "/suche", "/:subject_area", "/ausbildung", "/jobs", "/studium", "/events"]
}
